<mat-card-header>
	<mat-card-title>
		Merge Students
	</mat-card-title>
</mat-card-header>
<mat-divider> </mat-divider>

<app-search-children (shoppingCartChange)="searchChildrenShoppingCartEvent($event)"
	[selectUserRegion]="false"></app-search-children>

<mat-card>
	<mat-card-content>
		<table class="table table-borderless margin-top-sm" #compare>
			<thead>
				<tr>
					<td colspan="5">
						<mat-form-field class="w-100">
							<mat-label>
								From Child
							</mat-label>
							<mat-select (selectionChange)="chooseStudent1($event)" [(ngModel)]="student1"
								[disabled]="!shoppingCart || shoppingCart.length < 2">
								<mat-option
									*ngFor="let student of shoppingCart | removeFromArray: student2 ? [student2] : undefined: 'ID'; trackBy: trackItem"
									[value]="student">
									{{student.PERSON.LAST_NAME |
									titlecase}}{{(student.SECOND_LAST_NAME
									? ' ' + student.SECOND_LAST_NAME + ',': ',') | titlecase}}
									{{student.PERSON.FIRST_NAME |
									titlecase}}
									{{student.PERSON.MIDDLE_INITIAL | titlecase}}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</td>
					<td colspan="2" class="text-center">
						<mat-icon>
							double_arrow
						</mat-icon>
					</td>
					<td colspan="5">
						<mat-form-field class="w-100">
							<mat-label>
								Target Child
							</mat-label>
							<mat-select (selectionChange)="chooseStudent2($event)" [(ngModel)]="student2"
								[disabled]="!shoppingCart || shoppingCart.length < 2">
								<mat-option
									*ngFor="let student of shoppingCart | removeFromArray: student1 ? [student1] : undefined: 'ID'; trackBy: trackItem"
									[value]="student">
									{{student.PERSON.LAST_NAME |
									titlecase}}{{(student.SECOND_LAST_NAME
									? ' ' + student.SECOND_LAST_NAME + ',': ',') | titlecase}}
									{{student.PERSON.FIRST_NAME |
									titlecase}}
									{{student.PERSON.MIDDLE_INITIAL | titlecase}}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</td>
				</tr>
			</thead>
		</table>

		<div class="row gx-0" *ngIf="allowLoading">
			<div class="col-6">
				<mat-card-header>
					<mat-card-title>
						{{studentName1}} {{regions1}} <span class="danger h5">{{terminated1}}</span>
						<mat-icon *ngIf="isLoading || !studentName1">
							<mat-spinner diameter="20"> </mat-spinner>
						</mat-icon>
					</mat-card-title>
				</mat-card-header>
			</div>
			<div class="col-6">
				<mat-card-header>
					<mat-card-title>
						{{studentName2}} {{regions2}} <span class="danger h5">{{terminated2}}</span>
						<mat-icon *ngIf="isLoading || !studentName2">
							<mat-spinner diameter="20"> </mat-spinner>
						</mat-icon>
					</mat-card-title>
				</mat-card-header>
			</div>
		</div>
		<div class="row gx-0" *ngIf="allowLoading">
			<div class="col-12">
				<mat-card-content>
					<div *ngIf="!isLoading">

						<div class="row">
							<div class="col-6">
								<view-child-demographic [studentId]="studentId1"
									[studentHelperNumber]="1"></view-child-demographic>
							</div>
							<div class="col-6">
								<view-child-demographic [studentId]="studentId2"
									[studentHelperNumber]="2"></view-child-demographic>
							</div>
						</div>

						<div class="row margin-top-sm">
							<div class="col-6">
								<view-child-address-info [studentHelperNumber]="1"></view-child-address-info>
							</div>
							<div class="col-6">
								<view-child-address-info [studentHelperNumber]="2"></view-child-address-info>
							</div>
						</div>

						<div class="row margin-top-sm">
							<div class="col-6">
								<view-child-enrollment [studentId]="studentId1"
									[studentHelperNumber]="1"></view-child-enrollment>
							</div>
							<div class="col-6">
								<view-child-enrollment [studentId]="studentId2"
									[studentHelperNumber]="2"></view-child-enrollment>
							</div>
						</div>

						<div class="row margin-top-sm">
							<div class="col-6">
								<view-child-eligibility-status [studentId]="studentId1"></view-child-eligibility-status>
							</div>
							<div class="col-6">
								<view-child-eligibility-status [studentId]="studentId2"></view-child-eligibility-status>
							</div>
						</div>

						<div class="row margin-top-sm">
							<div class="col-6">
								<view-child-move-history [studentId]="studentId1"></view-child-move-history>
							</div>
							<div class="col-6">
								<view-child-move-history [studentId]="studentId2"></view-child-move-history>
							</div>
						</div>

						<div class="row margin-top-sm">
							<div class="col-6">
								<view-child-service-participation [studentId]="studentId1"
									[studentHelperNumber]="1"></view-child-service-participation>
							</div>
							<div class="col-6">
								<view-child-service-participation [studentId]="studentId2"
									[studentHelperNumber]="2"></view-child-service-participation>
							</div>
						</div>
					</div>
				</mat-card-content>
			</div>
		</div>

	</mat-card-content>
	<mat-card-actions>
		<div class="row">
			<div class="col-12">
				<h4 *ngIf="!shoppingCart || shoppingCart.length < 2">Please search and select two or more children to
					continue...</h4>

				<div class="row" *ngIf="shoppingCart && shoppingCart.length >= 2">
					<div class="col-12">
						<confirm-popover *ngIf="shoppingCart && shoppingCart.length >= 2" class="text-center"
							[type]="'button'" [buttonTxt]="'Add children to be resolved by their region'"
							[popoverMsg]="'Are you sure these children are duplicates? These children will be sent to their respectable regions to be resolved.'"
							[color]="'primary'" (onConfirm)="addDuplicateResolution()"
							[disabled]="isAdding || (!student1 || !studentId1 || !student2 || !studentId2)">
						</confirm-popover>
						<mat-icon *ngIf="isAdding">
							<mat-spinner diameter="20"> </mat-spinner>
						</mat-icon>
					</div>
				</div>

				<div class="row" *ngIf="showMsg">
					<div class="col-12">
						<app-msg [msg]="msg"></app-msg>
					</div>
				</div>
			</div>
		</div>
	</mat-card-actions>
</mat-card>